import { state } from "__common/store";

export enum PSEUDO_STAFF_USER_PERMISSIONS {
    engineering_layouts = "auth.engineering_layouts",
    source_code = 'auth.source_code',
    staggering_access = 'auth.staggering_access',
}

export const UBUILDER_SOFTWARE_GROUP = {
  solarmount_ascender_flush_permission: "auth.sm_ascender_flush_access",
}; 

export const userHasSmAscenderFlushPermission = () => {
  const { user: { permissions } } = state();
  return permissions.indexOf(UBUILDER_SOFTWARE_GROUP.solarmount_ascender_flush_permission) > -1;
};
export const PANEL_SPACINGS_UPDATOR_PERMISSION = 'auth.panel_spacings_updator';


export const PLANSET_DRAWING_GROUP = {
  planset_permission: 'tool.planset_drawing',
};
export const userPlansetPermission = () => {
  const { user: { permissions } } = state();
  return permissions.indexOf(PLANSET_DRAWING_GROUP.planset_permission) > -1;
};

export const DEAD_LOAD_FACTOR_MODIFICATION_PERMISSION = 'auth.dead_load_factor_modification_access';

export const MANDATORY_CENTRAL_SUPPORT_ACCESS_PERMISSION = 'auth.mandatory_central_support_access';

export const HIGHER_WIND_LOAD_ACCESS_PERMISSION = 'auth.higher_wind_load_access';

export const ACCESS_FOR_7_22_PERMISSION = 'auth.access_for_7_22_projects';

export const MARK_PROJECT_AS_TEST_ACCESS = 'auth.mark_project_as_test_access';

export const MANUAL_EXPOSURE_ACCESS_PERMISSION = 'auth.manual_exposure_access';

export const userHasManualExposurePermission = () => {
    const {user: {permissions}} = state();
    return permissions.indexOf(MANUAL_EXPOSURE_ACCESS_PERMISSION) > -1
}
